import { EventCard } from "@components/cards/EventCard"
import { ChipGroup } from "@components/controls/ChipGroup"
import { SearchBox } from "@components/controls/SearchBox"
import { Tabs } from "@components/controls/Tabs"
import { DirectoryHeader } from "@components/layout/DirectoryHeader"
import { ResultList, ResultListMode } from "@components/layout/ResultList"
import { StaggerTransitionRoot } from "@components/motion/Transition"
import { useInfiniteEventSearch } from "@hooks/queries"
import { getDateGroupHeading } from "@utils/dates"
import dayjs from "dayjs"
import { useSearchParams } from "eddev/routing"
import { defineView } from "eddev/views"
import { useCallback, useMemo } from "react"

/**
 * Event listing page
 */
export default defineView("archive-event", (props) => {
  // const [mode, setMode] = useState<"upcoming" | "past">("upcoming")

  let allBranches = props.branches!.nodes.filter((b) => b.branchSettings?.branchFlags?.includes("canSearch"))
  let allCategories = props.eventCategories!.nodes

  const [params, filter] = useSearchParams({
    branch: [] as string[],
    category: [] as string[],
    mode: "upcoming" as "upcoming" | "past",
    display: "card" as ResultListMode,
    search: "",
  })

  const lookup = useInfiniteEventSearch({
    limit: 30,
    search: filter.get("search"),
    branch: filter.get("branch"),
    category: filter.get("category"),
    mode: filter.get("mode"),
  })

  let results = useMemo(() => {
    let results = lookup.data?.nodes.flatMap((item) => {
      if (params.display === "row" && params.mode === "upcoming") {
        return item.dates.flatMap((date) => {
          return {
            ...item,
            keyDate: date.startDate,
            dates: [date],
          }
        })
      } else {
        return {
          ...item,
          keyDate: params.mode === "upcoming" ? item.dates[0].startDate : item.dates[0].endDate,
        }
      }
    })
    const today = dayjs().format("YYYY-MM-DD")
    results = results?.sort((a, b) => {
      const aKey = a.eventInfo?.featured ? "" : a.keyDate
      const bKey = b.eventInfo?.featured ? "" : b.keyDate
      return aKey?.localeCompare(bKey ?? "") ?? 0
    })
    if (params.mode === "past") {
      // results?.reverse()
    }
    return results
  }, [lookup.data, params.display, params.mode])

  return (
    <StaggerTransitionRoot>
      <DirectoryHeader
        heading={
          <Tabs
            id="mode"
            items={[
              {
                label: "Upcoming events",
                value: "upcoming",
              },
              {
                label: "Past events",
                value: "past",
              },
            ]}
            value={params.mode}
            onValueChange={filter.setter("mode")}
            className="border-none pb-1"
          />
        }
        displayMode={params.display}
        onDisplayModeChange={filter.setter("display")}
        tags={
          <div className="stack-y-1">
            <ChipGroup value={params.branch} onValueChange={filter.setter("branch")} options={allBranches.map((b) => ({ value: b.slug!, label: b.shortName! }))} />
            <ChipGroup value={params.category} onValueChange={filter.setter("category")} options={allCategories.map((b) => ({ value: b.slug!, label: b.name! }))} />
          </div>
        }
        search={<SearchBox onSearch={filter.setter("search")} placeholder="Search events..." />}
      />
      <ResultList
        mode={params.display}
        items={results}
        hasNextPage={lookup.hasNextPage}
        loading={lookup.isLoading}
        loadingNextPage={lookup.isFetchingNextPage}
        onFetchMore={useCallback(() => lookup.fetchNextPage(), [lookup])}
        component={EventCard}
        dynamicSizing="totalDependant"
        keyField="uri"
        mobileMode="row"
        getGroupHeading={params.display === "row" && params.mode === "upcoming" ? (item) => getDateGroupHeading((item.keyDate ?? "") + Math.random()) : undefined}
      />
      <div className="h-10" />
    </StaggerTransitionRoot>
  )
})
